import { render } from "./dashboard_cotizaciones_fixed.vue?vue&type=template&id=3dcbe6bf&scoped=true"
import script from "./dashboard_cotizaciones_fixed.vue?vue&type=script&lang=js"
export * from "./dashboard_cotizaciones_fixed.vue?vue&type=script&lang=js"

import "./dashboard_cotizaciones_fixed.vue?vue&type=style&index=0&id=3dcbe6bf&scoped=true&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dcbe6bf"]])

export default __exports__